/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import Container from '../../../Core/Container';
import checkmark from '../../../../images/green_checkmark.svg';
import { InternalStyledLink } from '../../../Core/Link/styles';
import arrowImg1 from '../../../../images/pcmc-arrow1.svg';
import arrowImg2 from '../../../../images/pcmc-arrow2.svg';
import purpleArrowImg1 from '../../../../images/pcmc-purple-arrow1.svg';
import purpleArrowImg2 from '../../../../images/pcmc-purple-arrow2.svg';

export const Section = styled.section`
  background-color: ${({ theme, backgroundColor }) =>
    !backgroundColor ? theme.colors.velvet : theme.colors[backgroundColor]};
  padding: 40px 0;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 70px 0 70px;
  }
`;

export const Grid = styled(Container)`
  margin-top: 0;
  margin-bottom: 0;
  color: ${props =>
    props.contentColor === 'velvet'
      ? themeGet('colors.white')
      : props.contentColor === 'pc-red'
        ? themeGet('colors.white')
        : themeGet('colors.main-text')};
`;

export const Header = styled.div`
  margin-bottom: 64px;

  p {
    text-align: center;
    color: inherit;
    font-size: 16px;
    line-height: 24px;
  }

  @media only screen and (max-width: calc(${themeGet(
      'breakpoints.md',
    )} - 1px)) {
    h2,
    p {
      br {
        display: none;
      }
    }
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 52px;

    p {
      font-size: 18px;
      line-height: 30px;
    }
  }

  ${Section}.card-steps-section & {
    margin-bottom: 40px;
    font-size: 18px;

    h2 {
      color: ${({ theme, headingColor }) =>
        headingColor ? theme.colors[headingColor] : 'inherit'};
    }

    p {
      font-size: 18px;
    }

    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
      margin-bottom: 62px;
    }
  }
`;

export const Headline = styled.h2`
  color: inherit;
  text-align: center;
  font-size: 1.5rem;
  line-height: 130%;
  margin-bottom: 20px;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 2.5rem;
    line-height: 130%;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.xlg}) {
    margin-bottom: 15px;
  }

  ${Section}.card-steps-section & {
    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
      margin-bottom: 8px;
      letter-spacing: normal;
    }
  }
`;

export const Tiles = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(auto, 270px));
  grid-template-rows: auto auto;
  grid-gap: ${({ numTiles }) => (numTiles === 1 ? '0' : '50px 0')};
  justify-content: center;
  max-width: ${({ numTiles }) => (numTiles === 3 ? '1048px' : '680px')};
  margin: 0 auto;
  justify-items: center;
  position: relative;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: repeat(1, minmax(auto, 1fr));
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: ${({ numTiles }) =>
      numTiles === 1
        ? 'repeat(1, minmax(auto, 1fr))'
        : 'repeat(2, minmax(0, 1fr))'};
    grid-gap: ${({ numTiles }) => (numTiles === 1 ? '0 75px' : '45px 75px')};
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: ${({ numTiles }) =>
      numTiles === 1
        ? 'repeat(1, minmax(auto, 1fr))'
        : numTiles === 3
          ? 'repeat(3, minmax(0, 1fr))'
          : 'repeat(2, minmax(0, 1fr))'};

    grid-gap: ${({ numTiles }) =>
      numTiles === 3 ? '0 32px' : numTiles >= 4 ? '45px 75px' : '0 75px'};
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.xlg}) {
    grid-gap: ${({ numTiles }) =>
      numTiles === 3 ? '0 75px' : numTiles >= 4 ? '45px 75px' : '0 75px'};
  }

  ${Section}.card-steps-section & {
    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      grid-template-columns: repeat(1, minmax(auto, 1fr));
    }

    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      grid-template-columns: ${({ numTiles }) =>
        numTiles === 1
          ? 'repeat(1, minmax(auto, 1fr))'
          : numTiles === 3
            ? 'repeat(3, minmax(0, 1fr))'
            : 'repeat(2, minmax(0, 1fr))'};
      &:before {
        content: '';
        background-image: url(${arrowImg1});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-color: transparent;
        display: block;
        position: absolute;
        z-index: 2;
        width: 60px;
        height: 40px;
        top: calc(50% - 20px);
        left: 30%;
      }
      &:after {
        content: '';
        background-image: url(${arrowImg2});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-color: transparent;
        display: block;
        position: absolute;
        z-index: 2;
        width: 60px;
        height: 40px;
        top: calc(50% - 20px);
        left: 64%;
      }
    }
  }

  ${Section}.points-reward-section & {
    grid-template-columns: repeat(1, minmax(auto, 1fr));

    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      grid-gap: 0px 75px;
    }
  }
`;

export const TilesBackground = styled.div`
  background: linear-gradient(to bottom, #eeaba1 0%, #f3736d 100%);
  position: absolute;
  width: 72px;
  top: 12px;
  height: calc(100% - 12px);

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    background: linear-gradient(to right, #eeaba1 0%, #f3736d 100%);
    width: calc(100% - 64px);
    top: calc(50% - 42px);
    height: 84px;
  }
`;

export const Tile = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  border-radius: 30px;
  padding: 30px 30px 40px;
  min-height: 300px;
  max-width: 300px;
  margin-bottom: ${({ imageToggle }) => (imageToggle === true ? '1rem' : '0')};
  margin-top: ${({ imageToggle }) => (imageToggle === true ? '1rem' : '12px')};

  &::before {
    content: '';
    position: absolute;
    height: 43.62px;
    width: 43.65px;
    background: center / contain no-repeat url(${checkmark});
    top: calc(-1 * (43.62px / 2));
    left: 25px;
  }

  &:after {
    content: '${props => props.tileNum}';
    display: ${props => (props.cardNumbering === true ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -30px;
    left: -30px;
    width: 60px;
    height: 60px;
    text-align: center;
    font-size: 2.5rem;
    font-weight: ${themeGet('fontWeights.medium')};
    color: ${themeGet('colors.white')};
    background-color: ${themeGet('colors.pc-red')};
    border-radius: 100%;
  }

  p {
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;

    a {
      font-size: inherit;
      line-height: inherit;
    }
  }

  ${InternalStyledLink} {
    & > svg {
      display: none;
    }
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 30px 20px 40px;

    &::before {
      left: 15px;
    }
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 30px 20px 50px 30px;
    margin: 0;

    &::before {
      left: 25px;
    }

    p {
      font-size: 14px;
      line-height: 18px;
    }
  }

  ${Section}.card-steps-section & {
    text-align: center;
    padding: ${({ imageToggle }) => (imageToggle === true ? '0' : '20px')};
    min-height: 226px;
    width: 250px;
    color: ${themeGet('colors.pc-red')};

    &:nth-child(2n-1) {
      color: ${themeGet('colors.velvet')};
    }

    &::before {
      display: none;
    }

    p {
      color: ${themeGet('colors.main-text')};
      padding: ${({ imageToggle }) =>
        imageToggle === true ? '0 40px 40px' : '0'};
    }

    &:nth-child(2) {
      &:after {
        content: '';
        background-image: url(${arrowImg1});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-color: transparent;
        display: block;
        position: absolute;
        width: 50px;
        height: 30px;
        top: calc(100% + 15px);
        left: calc(50% - 25px);
        z-index: 2;
        transform: rotate(90deg);
        border-radius: 0;
      }
    }
    &:nth-child(3) {
      &:after {
        content: '';
        background-image: url(${arrowImg2});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-color: transparent;
        display: block;
        position: absolute;
        width: 50px;
        height: 30px;
        top: calc(100% + 10px);
        left: calc(50% - 25px);
        z-index: 2;
        transform: rotate(135deg);
        border-radius: 0;
      }
    }

    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
      padding: ${({ imageToggle }) =>
        imageToggle === true ? '0' : '18px 30px'};
      min-height: 248px;
      width: 268px;
    }
    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      p {
        font-size: 16px;
        line-height: 20px;
      }
      &:nth-child(2) {
        &:after {
          display: none;
        }
      }
      &:nth-child(3) {
        &:after {
          display: none;
        }
      }
    }
  }

  ${Section}.points-reward-section & {
    text-align: center;
    min-height: 226px;
    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        margin-top: ${({ imageToggle }) =>
          imageToggle === true ? '130px' : '0px'};
    }

    p {
      font-size: 16px;
      line-height: 20px;
    }

    &::before {
      display: none;
    }

    &:first-child {
      &:after {
        @media only screen and (min-width: ${({ theme }) =>
          theme.breakpoints.lg}) {
          content: '';
          background-image: url(${purpleArrowImg1});
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          background-color: transparent;
          display: block;
          right: 2%;
          width: 21%;
          bottom: 30%;
          left: 102%;
          height: 120%;
        }
      }
    }
    &:nth-child(2) {
      &:after {
        @media only screen and (min-width: ${({ theme }) =>
          theme.breakpoints.lg}) {
          content: '';
          background-image: url(${purpleArrowImg2});
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          background-color: transparent;
          display: block;
          right: 2%;
          width: 19%;
          bottom: 30%;
          left: 103%;
          height: 115%;
        }
      }
  }
`;

export const TileHeadline = styled.h3`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 20px;
  line-height: 25px;
  margin-bottom: 12.5px;
  color: ${({ theme, headingColor }) =>
    headingColor ? theme.colors[`${headingColor}`] : theme.colors[`main-text`]};

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 25px;
    line-height: 30px;
  }

  ${Section}.card-steps-section & {
    font-size: 38px;
    margin: ${({ imageToggle }) =>
      imageToggle === true ? '40px 0 24px' : '12px 0 24px'};

    &:lang(fr) {
      font-size: 22px;
    }

    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: 50px;
      letter-spacing: 1.5px;
    }
  }

  ${Section}.points-reward-section & {
    font-size: 32px;
    line-height: 44px;
  }
`;

export const TileSubhead = styled.p`
  && {
    color: ${({ theme }) => theme.colors[`pc-red`]};
    font-size: 55px;
    line-height: 64px;
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    letter-spacing: -3.0303px;
    position: relative;
    display: inline;
  }

  &::after {
    content: '';
    display: block;
    background: center / 35px 25px no-repeat url(${({ icon }) => icon});
    width: 36px;
    height: 26px;
    position: absolute;
    right: -40px;
    top: 0px;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    && {
      font-size: 42px;
      letter-spacing: -2.0303px;
      line-height: 51px;
    }
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    && {
      font-size: 55px;
      line-height: 64px;
    }
  }

  ${Section}.card-steps-section & {
    &::after {
      background-size: 36px 36px;
      width: auto;
      position: initial;
      height: 36px;
    }

    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
      &::after {
        background-size: 50px 50px;
        height: 50px;
      }
    }
  }
`;

export const BubbleImg = styled.div`
  position: absolute;
  right: -50px;
  bottom: -45px;
  width: 100px;
  height: 105px;

  ${Section}.points-reward-section & {
    display: none;
    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      display: block;
      width: auto;
      right: 0px;
      left: 0px;
      top: -152px;
    }
  }
`;

export const Img = styled(Image)``;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 55px;

  a {
    margin: 10px;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-top: 60px;
  }
`;
